"use client"

import { DashboardLayout } from "@/components/dashboard/dashboard-layout"
import { KycStatusBanner } from "@/src/components/kyc/KycAlerts"
import { Construction, Rocket, Clock, CheckCircle2 } from "lucide-react"

export default function ComingSoonPage() {
  return (
    <DashboardLayout>
      <div className="max-w-4xl mx-auto">
        {/* KYC Status Banner - Show if pending verification */}
        <KycStatusBanner />
        
        <div className="flex flex-col items-center justify-center min-h-[70vh] text-center px-4">
          {/* Icon */}
          <div className="mb-8 relative">
            <div className="w-32 h-32 bg-gradient-to-br from-brand-primary to-brand-blue rounded-full flex items-center justify-center shadow-2xl">
              <Construction className="w-16 h-16 text-white" strokeWidth={2} />
            </div>
            <div className="absolute -top-2 -right-2 w-12 h-12 bg-brand-red rounded-full flex items-center justify-center shadow-lg">
              <Rocket className="w-6 h-6 text-white" />
            </div>
          </div>

          {/* Main Message */}
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            กำลังพัฒนา
          </h1>
          <p className="text-xl md:text-2xl text-brand-primary font-semibold mb-6">
            Coming Soon
          </p>

          {/* Description */}
          <p className="text-lg text-gray-600 max-w-2xl mb-12">
            เรากำลังพัฒนาฟีเจอร์ใหม่ๆ เพื่อมอบประสบการณ์ที่ดีที่สุดให้กับคุณ
            <br />
            กรุณารอติดตามในเร็วๆ นี้
          </p>

          {/* Features List */}
          <div className="grid md:grid-cols-3 gap-6 w-full max-w-3xl">
            <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 bg-brand-primary/10 rounded-lg flex items-center justify-center mb-4 mx-auto">
                <Clock className="w-6 h-6 text-brand-primary" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">เร็วๆ นี้</h3>
              <p className="text-sm text-gray-600">
                ระบบจะเปิดให้บริการในเร็วๆ นี้
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 bg-brand-blue/10 rounded-lg flex items-center justify-center mb-4 mx-auto">
                <CheckCircle2 className="w-6 h-6 text-brand-blue" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">คุณภาพสูง</h3>
              <p className="text-sm text-gray-600">
                พัฒนาด้วยมาตรฐานสูงสุด
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 bg-brand-red/10 rounded-lg flex items-center justify-center mb-4 mx-auto">
                <Rocket className="w-6 h-6 text-brand-red" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">ใช้งานง่าย</h3>
              <p className="text-sm text-gray-600">
                ออกแบบให้ใช้งานง่าย สะดวก
              </p>
            </div>
          </div>

          {/* Progress Indicator */}
          <div className="mt-12 w-full max-w-md">
            <div className="bg-gray-200 rounded-full h-2 overflow-hidden">
              <div className="bg-gradient-to-r from-brand-primary via-brand-blue to-brand-red h-full rounded-full animate-pulse" style={{ width: '75%' }}></div>
            </div>
            <p className="text-sm text-gray-500 mt-3">กำลังพัฒนา 75%</p>
          </div>
        </div>
      </div>
    </DashboardLayout>
  )
}
